import requestv2 from "~/utils/http-v2";

const recurringVoucherApi = {
	gets : async (params) => {
		const url = 'v2/recurring-voucher';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/recurring-voucher';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/recurring-voucher/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/recurring-voucher/${id}`;
		return await requestv2.delete(url);
	},
};

export default recurringVoucherApi;
